import { createContext } from "react";
const TempleMasterContext = createContext({});

export default TempleMasterContext;
